import {SERVICE_DETAILS} from './ServiceType'


const initialState={
    UserName:10,
    Password:'',
    Role:'',
    Id:''
}

const serviceReducer=(state=initialState,action)=>
{   
    switch(action.type)
    {
        case SERVICE_DETAILS: return{
            ...state,
            UserName:state.UserName,
            Password:state.Password,
            Role:state.Role,
            Id:state.Id
        }
        default: return state
    }
}

export default serviceReducer;